/**
 * Wizard sidebar + page titles/subtitles — aligned with park-v4.html STEPS + step-wrapper copy.
 */

export const WIZARD_NAV_COPY = [
    { name: 'Address',  description: 'Find & confirm your property' },
    { name: 'Geofence', description: 'Confirm or redraw the AI-suggested boundary' },
    { name: 'Details',  description: 'Review what AI found' },
    { name: 'Photos',   description: 'Upload at least 3' },
    { name: 'Pricing',  description: 'Spots & hourly rate' },
    { name: 'Insurance', description: 'Additionally insured' },
    { name: 'Preview',  description: 'Review & submit' },
];

export const WIZARD_PAGE_COPY = {
    address: {
        title: 'Add your property address',
        description:
            'Search by street address or business name — we\'ll auto-pin the location, show you a Street View to confirm, and start enriching your property profile in the background.',
    },
    geofence: {
        title: 'Geofence',
        description:
            'We\'ve identified the areas on your property that appear suitable for truck parking. Please review the suggested boundaries, remove any areas that don\'t belong, and adjust them as needed. Then set your entrance and exit points so drivers know where to enter, park, and leave.',
        descriptionNoAiBoundary:
            'We couldn\'t identify any truck parking areas for this property. Please draw the parking area manually, then set your entrance and exit points so drivers know where to enter, park, and leave.',
    },
    details: {
        title: 'Review & Confirm Your Property Details',
        description:
            'We\'ve gathered information about your property to help you get started. Please review each section, confirm what\'s correct, and update anything that needs changes. Your changes won\'t be saved until you confirm them.',
    },
    photos: {
        title: 'Help Drivers Find Your Property',
        description:
            'We\'ve gathered candidate photos from Street View, Google Places, and satellite imagery. Please review the suggested photos, remove any that don\'t represent your property, and upload additional photos if needed.',
    },
    pricing: {
        title: 'Set your pricing',
        description:
            'Enter your hourly rate and the maximum number of truck parking spaces available. Your projected monthly revenue updates automatically.',
    },
    insurance: {
        title: 'Additional Insured Election and Contractual Requirement',
        description:
            'ParkPro carries a blanket policy that names participating Hosts as Additional Insured. Confirming below is both your request for that coverage and the written contractual requirement your insurance carrier looks for.',
    },
    preview: {
        title: 'Review & submit for approval',
        description:
            'Final look before this goes to ParkPro Ops. Click "Edit listing" anywhere to fix anything inline — no need to step back through the wizard.',
    },
};
